import { Growl } from 'angular/custom/services/growl.service';
import { bind } from 'app/_decorators/bind.decorator';
import * as angular from 'angular';

class StorageLocationDetailsMarketCtrl implements ng.IController {
    public isEditMode: boolean;
    public isCreateMode: boolean;
    public storageLocation: StorageLocationDto;
    public isEditable = this.isCreateMode || this.isEditMode;
    public marketExpanded: boolean = true;
    public showInjectionSearch: boolean[] = [];
    public showWithdrawalSearch: boolean[] = [];
    public withdrawalPointsNumber: number[] = [];
    public injectionPointsNumber: number[] = [];
    public INPUT_ADDON: any = {};
    public possibleMarketAreas: string[][] = [];

    constructor(
        private $window,
        private TransmissionSystemOperator,
        private networkPointSearchService,
        private authService,
        private growl: Growl,
        private $location: ng.ILocationService,
        private $filter: ng.IFilterService
    ) {
        this.INPUT_ADDON = this.networkPointSearchService.INPUT_ADDON;
    }

    $onInit() {
        if (this.isEditMode) {
            for (
                var i = 0;
                i < this.storageLocation.marketAreaList.length;
                i++
            ) {
                this.initMarketAreas(i);
            }
        }

        if (this.isCreateMode) {
            this.initMarketAreas(0);
            this.storageLocation.marketAreaList = [''];

            this.storageLocation.injectionPoints = [];
            this.showInjectionSearch[0] = true;
            this.injectionPointsNumber[0] = 0;

            this.storageLocation.withdrawalPoints = [];
            this.showWithdrawalSearch[0] = true;
            this.withdrawalPointsNumber[0] = 0;
        } else {
            if (this.storageLocation.marketAreaList.length > 0) {
                for (
                    var i = 0;
                    i < this.storageLocation.marketAreaList.length;
                    i++
                ) {
                    this.withdrawalPointsNumber[i] = 0;
                    this.showWithdrawalSearch[i] = false;
                    for (let withdrawalPoint of this.storageLocation
                        .withdrawalPoints) {
                        if (
                            withdrawalPoint.marketArea0 ==
                            this.storageLocation.marketAreaList[i]
                        ) {
                            this.withdrawalPointsNumber[i]++;
                        }
                    }
                    this.injectionPointsNumber[i] = 0;
                    this.showInjectionSearch[i] = false;
                    for (let injectionPoint of this.storageLocation
                        .injectionPoints) {
                        if (
                            injectionPoint.marketArea0 ==
                            this.storageLocation.marketAreaList[i]
                        ) {
                            this.injectionPointsNumber[i]++;
                        }
                    }
                }
            }
        }
    }

    private initMarketAreas(index: number): void {
        this.possibleMarketAreas.push([]);
        this.TransmissionSystemOperator.marketAreas((res: string[]) => {
            angular.forEach(res, (marketArea) => {
                var indexInStorageLocation =
                    this.storageLocation.marketAreaList.indexOf(marketArea);
                if (
                    indexInStorageLocation == -1 ||
                    index == indexInStorageLocation
                ) {
                    this.possibleMarketAreas[index].push(marketArea);
                }
            });
        });
    }

    @bind
    public onNetworkPointSelection(selectedNetworkPoints: NetworkPointDto) {
        if (selectedNetworkPoints.direction == 'EXIT') {
            let alreadyAdded = this.$filter('filter')(
                this.storageLocation.injectionPoints,
                { id: selectedNetworkPoints.id },
                true
            );

            if (alreadyAdded.length <= 0) {
                this.storageLocation.injectionPoints.push(
                    selectedNetworkPoints
                );
            } else {
                this.growl.show(
                    'The network point is already selected as an injection point',
                    'danger',
                    { delay: 2000 }
                );
            }

            var i = this.storageLocation.marketAreaList.indexOf(
                selectedNetworkPoints.marketArea0
            );
            this.showInjectionSearch[i] = false;
            this.injectionPointsNumber[i]++;
        }
        if (selectedNetworkPoints.direction == 'ENTRY') {
            let alreadyAdded = this.$filter('filter')(
                this.storageLocation.withdrawalPoints,
                { id: selectedNetworkPoints.id },
                true
            );
            if (alreadyAdded.length <= 0) {
                this.storageLocation.withdrawalPoints.push(
                    selectedNetworkPoints
                );
            } else {
                this.growl.show(
                    'The network point is already selected as a withdrawal point',
                    'danger',
                    { delay: 2000 }
                );
            }

            var i = this.storageLocation.marketAreaList.indexOf(
                selectedNetworkPoints.marketArea0
            );
            this.showWithdrawalSearch[i] = false;
            this.withdrawalPointsNumber[i]++;
        }
    }

    public removeNetworkPointFromStorageLocation(
        direction: Direction,
        index: number
    ) {
        if (direction == 'EXIT') {
            this.injectionPointsNumber[
                this.storageLocation.marketAreaList.indexOf(
                    this.storageLocation.injectionPoints[index].marketArea0
                )
            ]--;
            this.storageLocation.injectionPoints.splice(index, 1);
        }
        if (direction == 'ENTRY') {
            this.withdrawalPointsNumber[
                this.storageLocation.marketAreaList.indexOf(
                    this.storageLocation.withdrawalPoints[index].marketArea0
                )
            ]--;
            this.storageLocation.withdrawalPoints.splice(index, 1);
        }
    }

    public marketAreaChange(index: number, oldValue: string) {
        for (var i = 0; i < this.possibleMarketAreas.length; i++) {
            if (i != index) {
                if (oldValue != '') {
                    this.possibleMarketAreas[i].push(oldValue);
                }
                this.possibleMarketAreas[i].splice(
                    this.possibleMarketAreas[i].indexOf(
                        this.storageLocation.marketAreaList[index]
                    ),
                    1
                );
            }
        }

        for (var i = 0; i < this.storageLocation.injectionPoints.length; i++) {
            if (
                this.storageLocation.injectionPoints[i].marketArea0 == oldValue
            ) {
                this.storageLocation.injectionPoints.splice(i, 1);
            }
        }
        this.showInjectionSearch[index] = true;

        for (var i = 0; i < this.storageLocation.withdrawalPoints.length; i++) {
            if (
                this.storageLocation.withdrawalPoints[i].marketArea0 == oldValue
            ) {
                this.storageLocation.withdrawalPoints.splice(i, 1);
            }
        }
        this.showWithdrawalSearch[index] = true;
    }

    public addMarketArea() {
        this.storageLocation.marketAreaList.push('');
        this.showInjectionSearch.push(true);
        this.showWithdrawalSearch.push(true);
        this.withdrawalPointsNumber.push(0);
        this.injectionPointsNumber.push(0);
        this.initMarketAreas(this.storageLocation.marketAreaList.length - 1);
    }

    public removeMarketArea(index: number, marketArea: string) {
        for (var i = 0; i < this.possibleMarketAreas.length; i++) {
            if (i != index) {
                if (marketArea != '') {
                    this.possibleMarketAreas[i].push(
                        this.storageLocation.marketAreaList[index]
                    );
                }
            }
        }

        this.storageLocation.marketAreaList.splice(index, 1);

        for (
            var i = this.storageLocation.injectionPoints.length - 1;
            i >= 0;
            i--
        ) {
            if (
                this.storageLocation.injectionPoints[i].marketArea0 ==
                marketArea
            ) {
                this.storageLocation.injectionPoints.splice(i, 1);
            }
        }

        for (
            var i = this.storageLocation.withdrawalPoints.length - 1;
            i >= 0;
            i--
        ) {
            if (
                this.storageLocation.withdrawalPoints[i].marketArea0 ==
                marketArea
            ) {
                this.storageLocation.withdrawalPoints.splice(i, 1);
            }
        }

        this.showInjectionSearch.splice(index, 1);
        this.showWithdrawalSearch.splice(index, 1);
        this.withdrawalPointsNumber.splice(index, 1);
        this.injectionPointsNumber.splice(index, 1);
        this.possibleMarketAreas.splice(index, 1);

        if (this.storageLocation.marketAreaList.length == 0) {
            this.addMarketArea();
        }
    }
}

angular.module('app').component('pkpStorageLocationDetailsMarket', {
    controller: StorageLocationDetailsMarketCtrl,
    template:
        require('app/storage-location/storage-location-details-market.component.html'),
    bindings: {
        form: '<',
        storageLocation: '=',
        isEditMode: '<',
        isCreateMode: '<'
    }
});
